<template>
<div style="padding-top:-2px;margin-top:-2px;">
    <v-label><b>{{ label }}</b></v-label>
    <vc-select-generic style="margin-top:-18px" class="text" itemtext="GenDescription" itemvalue="GenID" :disabled="disabled" id="GenDescription" :value="value" :return-object="returnObject" @input="input($event)" :config="config" :full="full" :text="text" :clearable="clearable" :noDefault="noDefault">
    </vc-select-generic>
</div>
</template>

<script>
import _sGenericService from "@/services/General/GenGenericService";
export default {
    name: "SelectProperty",
    components: {},
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        value: null,
        text: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: "",
        },
        table: {
            type: String,
            default: ""
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
        noDefault: {
            type: Boolean,
            default: false,
        },
        full: {
            type: Boolean,
            default: false,
        },
    },
    watch: {

        value(value) {
            this.item = value;
        },
    },
    methods: {
        input(val) {
            this.$emit("input", val);
        },
    },
    data: () => ({
        item: 0,
        val: "",
        items: [],
        config: {},
    }),

    created() {
        console.log("this.table",this.table)
        this.config = {
            url: _sGenericService.getUrlSearchProperty(),
            title: this.label,
            params: {
                search: this.table
                /* requestID: this.$fun.getUserID() */
            },
        };
    },
};
</script>
